import GenericOption from './GenericOption'

export default GenericOption
